"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADMIN_SUBMISSION_GENERATE_FAKE_LEADERBOARD_DATA_MUTATION = exports.AdminSubmissionGenerateFakeLeaderboardDataInputGql = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.AdminSubmissionGenerateFakeLeaderboardDataInputGql = (0, graphql_tag_1.default) `
  input AdminSubmissionGenerateFakeLeaderboardDataInput {
    id: String!
  }
`;
exports.ADMIN_SUBMISSION_GENERATE_FAKE_LEADERBOARD_DATA_MUTATION = (0, graphql_tag_1.default) `
  mutation AdminSubmissionGenerateFakeLeaderboardData($input: AdminSubmissionGenerateFakeLeaderboardDataInput!) {
    adminSubmissionGenerateFakeLeaderboardData(input: $input) {
      id
      status
      gameId
      slug
    }
  }
`;
